import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex py-1"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_TutorialsModuleEdition = _resolveComponent("TutorialsModuleEdition")!
  const _component_TutorialsModule = _resolveComponent("TutorialsModule")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.step === 'modules')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_v_text_field_filled, {
            modelValue: _ctx.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
            label: "Rechercher",
            outlined: "",
            density: "compact",
            "append-inner-icon": "$search",
            clearable: "",
            "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.search = ''))
          }, null, 8, ["modelValue"]),
          (_ctx.enableWrite && _ctx.localEnv !== 'production')
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                class: "ml-2 mr-0 elevation-0",
                rounded: "xl",
                density: "compact",
                variant: "flat",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.editLearningModule('')))
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" Ajouter ")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window, {
              modelValue: _ctx.step,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window_item, { value: "modules" }, {
                  default: _withCtx(() => [
                    (_ctx.tutorialsModules.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          (_ctx.tutorialsModules.length)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.tutorialsModules, (tutorialsModule, index) => {
                                return (_openBlock(), _createBlock(_component_v_list, {
                                  key: index,
                                  value: index,
                                  onClick: _withModifiers(($event: any) => (_ctx.navigateToLearningModule(tutorialsModule.id)), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item, {
                                      rounded: "xl",
                                      lines: "two",
                                      border: ""
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          "x-small": "",
                                          icon: 
                                                _ctx.openModuleIndex === index
                                                    ? '$fa-chevron-down'
                                                    : '$fa-chevron-right'
                                            ,
                                          onClick: _withModifiers(($event: any) => (_ctx.toggleModule(index)), ["stop"])
                                        }, null, 8, ["icon", "onClick"])
                                      ]),
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                          activator: _withCtx(({ props }) => [
                                            (_ctx.enableWrite && _ctx.localEnv !== 'production')
                                              ? (_openBlock(), _createBlock(_component_v_btn_icon, _mergeProps({
                                                  key: 0,
                                                  icon: "$oss-edit",
                                                  small: "",
                                                  class: "elevation-0",
                                                  color: "secondary",
                                                  ref_for: true
                                                }, props, {
                                                  onClick: _withModifiers(($event: any) => (
                                                        _ctx.editLearningModule(tutorialsModule.id)
                                                    ), ["stop"])
                                                }), null, 16, ["onClick"]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          default: _withCtx(() => [
                                            _cache[6] || (_cache[6] = _createElementVNode("span", null, "Editer", -1))
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                          activator: _withCtx(({ props }) => [
                                            (!_ctx.isModuleCompleted(tutorialsModule))
                                              ? (_openBlock(), _createBlock(_component_v_progress_circular, _mergeProps({
                                                  key: 0,
                                                  ref_for: true
                                                }, props, {
                                                  "model-value": 
                                                        _ctx.calculateModuleProgress(tutorialsModule)
                                                    ,
                                                  size: "24",
                                                  width: "3",
                                                  color: "primary",
                                                  rounded: ""
                                                }), null, 16, ["model-value"]))
                                              : _createCommentVNode("", true),
                                            (_ctx.isModuleCompleted(tutorialsModule))
                                              ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({
                                                  key: 1,
                                                  size: "24",
                                                  width: "3",
                                                  ref_for: true
                                                }, props), {
                                                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                    _createTextVNode(" $oss-circle-check ")
                                                  ])),
                                                  _: 2
                                                }, 1040))
                                              : _createCommentVNode("", true)
                                          ]),
                                          default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.getModuleStatus(tutorialsModule)), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(tutorialsModule.name), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_list_item_subtitle, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(tutorialsModule.description ||
                                            "Pas de description disponible"), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    (_ctx.openModuleIndex === index)
                                      ? (_openBlock(), _createBlock(_component_v_list, {
                                          key: 0,
                                          class: "ml-4"
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tutorialsModule.learningObjects, (learningObject, i) => {
                                              return (_openBlock(), _createBlock(_component_v_list_item, {
                                                key: i,
                                                class: "mb-2",
                                                onClick: _withModifiers(($event: any) => (
                                            _ctx.goToLearningObject(
                                                tutorialsModule.id,
                                                learningObject.id,
                                            )
                                        ), ["stop"]),
                                                rounded: "xl",
                                                border: "",
                                                lines: "two"
                                              }, {
                                                prepend: _withCtx(() => [
                                                  _createVNode(_component_v_icon, { icon: "$fa-photo-video" })
                                                ]),
                                                append: _withCtx(() => [
                                                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                                                    activator: _withCtx(({ props }) => [
                                                      (!_ctx.isTutorialCompleted(learningObject))
                                                        ? (_openBlock(), _createBlock(_component_v_progress_circular, _mergeProps({
                                                            key: 0,
                                                            color: "primary",
                                                            ref_for: true
                                                          }, props, {
                                                            "model-value": 
                                                            _ctx.calculateTutorialProgress(
                                                                learningObject,
                                                            )
                                                        ,
                                                            size: "24",
                                                            width: "3",
                                                            rounded: ""
                                                          }), null, 16, ["model-value"]))
                                                        : _createCommentVNode("", true),
                                                      (_ctx.isTutorialCompleted(learningObject))
                                                        ? (_openBlock(), _createBlock(_component_v_icon, _mergeProps({
                                                            key: 1,
                                                            size: "24",
                                                            width: "3",
                                                            ref_for: true
                                                          }, props, { color: "primary" }), {
                                                            default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                              _createTextVNode(" $oss-circle-check ")
                                                            ])),
                                                            _: 2
                                                          }, 1040))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createElementVNode("span", null, _toDisplayString(_ctx.getTutorialStatus(learningObject)), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item_title, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(learningObject.name), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024),
                                                  _createVNode(_component_v_list_item_subtitle, null, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(learningObject.description ||
                                                "Pas de description disponible"), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["value", "onClick"]))
                              }), 128))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(_component_v_alert, {
                            density: "compact",
                            variant: "outlined",
                            color: "primary",
                            icon: "$fa-exclamation-triangle"
                          }, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                              _createTextVNode(" Aucun module d'apprentissage disponible ")
                            ])),
                            _: 1
                          })
                        ]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "editionModule" }, {
                  default: _withCtx(() => [
                    (_ctx.step === 'editionModule')
                      ? (_openBlock(), _createBlock(_component_TutorialsModuleEdition, {
                          key: 0,
                          learningModuleId: _ctx.learningModuleId,
                          onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.refresh()))
                        }, null, 8, ["learningModuleId"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, { value: "module" }, {
                  default: _withCtx(() => [
                    (_ctx.learningModuleId && _ctx.step === 'module')
                      ? (_openBlock(), _createBlock(_component_TutorialsModule, {
                          key: 0,
                          learningModuleId: _ctx.learningModuleId,
                          learningObjectId: _ctx.learningObjectId,
                          onUpsertArcadeEvents: _ctx.upsertAllArcadeEvents,
                          ref: "tutorialsModule"
                        }, null, 8, ["learningModuleId", "learningObjectId", "onUpsertArcadeEvents"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}